<template>
  <form @submit.prevent="createFeeData" class="form">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ $t('add_fee') }}</h5>

        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">

                <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>

        </div>

      </div>
      <div class="modal-body">

        <div class="d-flex flex-column mb-8 fv-row">
          <!--begin::Label-->
          <label class="d-flex align-items-center fs-6 fw-bold mb-2">
            <span class="required">{{$t('fee_title')}}</span>
          </label>
          <!--end::Label-->
          <input type="text" class="form-control form-control-solid" v-model="formData.title" required :placeholder="$t('fee_title_placeholder')" />
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
        <button type="submit"
                class="btn btn-sm btn-primary fw-bolder"
                :disabled="processCreating" style="margin-right: 10px;">
          <span class="indicator-label">{{ $t('button.save') }}</span>
          <span class="indicator-progress" v-show="processCreating">{{  $t('loading') }}
                          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
        </button>
      </div>
    </div>
  </form>
</template>

<script setup>

import {computed, ref} from "vue";
import {useStore} from "vuex";

const store = useStore()
const props = defineProps({
  fee: { type: Object, default: {}}
})
const emits = defineEmits(['afterCreated'])

const formData = ref(props.fee)
const processCreating = ref(false)
async function loadFees () {
  await store.dispatch('fees/loadFees')
}
function createFeeData(){
  processCreating.value = true
  store.dispatch('fees/createFee', formData.value)
      .then((response) => {
        loadFees()
        processCreating.value = false
        emits('afterCreated', response.data.data)
        formData.value = {}
        window.toastr['success'](i18n.global.t('notification.fee_created'))
      })
      .catch(err => {
        processCreating.value = false
      })
}


</script>

<style scoped>

</style>